
import React, { useEffect, useState } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

const Banner = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

useEffect(() => {
  handleShow(true);
}, []);
  return (
    <>
      <section className="main-banner ">
        <div className="container ">
          <div className="main-heading">
            <h6>Governance</h6>
            <h5>KingKong DAO</h5>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.</p>
          </div>
          <div className="bottom-box">
            <div className="left">
              <h6>Treasury</h6>
              <div className="inner-text">
              <h5>28,307</h5>
              <h4>$43,252,198.00</h4>
              </div>
            </div>
            <div className="right">
              <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
            </div>
          </div>
          <div className="proposal-content">
            <div className="main-heading-proposal">
              <div className="left">
                <h5>Proposal</h5>
              </div>
              <div className="right">
                <p>Connect wallet to make a proposal.</p>
                <Link to="/simpleproposal"><button className="btn-submit">Submit Proposal</button></Link>
              </div>
            </div>
            <div className="inner-box">
              <div className="left-side">
                <h6><span>137</span> Mucho Love 4 Month Extension</h6>
              </div>
              <div className="right-side">
                <div className="clock-div">
                <h6><img src="\assets\clock-icon.svg" alt="img" className="img-fluid mr-2" />Starts in 14 hours</h6>  
                </div>
                <Link to="/executed"><button className="btn-pending">Pending</button></Link>
              </div>
            </div>
            <div className="inner-box">
              <div className="left-side">
                <h6><span>137</span> Mucho Love 4 Month Extension</h6>
              </div>
              <div className="right-side">
               
                <button className="btn-queue">Queued</button>
              </div>
            </div>
            <div className="inner-box">
              <div className="left-side">
                <h6><span>137</span> Mucho Love 4 Month Extension</h6>
              </div>
              <div className="right-side">
                <button className="btn-defeat">Defeated</button>
              </div>
            </div>
            <div className="inner-box">
              <div className="left-side">
                <h6><span>137</span> Mucho Love 4 Month Extension</h6>
              </div>
              <div className="right-side">
                
                <Link to="/executed"><button className="btn-executed">Executed</button></Link>
              </div>
            </div>
            <div className="inner-box">
              <div className="left-side">
                <h6><span>137</span> Mucho Love 4 Month Extension</h6>
              </div>
              <div className="right-side">
             
                <button className="btn-cancel">Canceled</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal className="modal-showstart" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>The current version is only user interface please don’t consider it functional</h6>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Banner;
